import Immutable from "immutable";
import { cloneDeep } from "lodash";

const populateEmployments = (candidateProfile, formData) => {
  const employments = candidateProfile?.employment;
  if (!Array.isArray(employments) || employments.length === 0) {
    return;
  }

  let experiences = [];
  employments.forEach((item) => {
    const position = item.positionHistories?.[0];
    if (!position) return;

    const { title, start, end, descriptions } = position;

    const emp = {
      title: title || null,
      startDate: start || null,
      endDate: end || null,
      employer: item.organization?.name || null,
    };

    if (Array.isArray(descriptions) && descriptions.length > 0) {
      emp.descriptions = [...descriptions];
    }

    if (!Array.isArray(formData.employment)) {
        formData.employment = [];
    }

    experiences.push(emp);
  });

  formData.employment = experiences;
};

const populateEducations = (candidateProfile, formData) => {
  const educations = candidateProfile?.education;

  console.log("populateEducations", educations);

  if (!Array.isArray(educations) || educations.length === 0) {
    return;
  }
  
  let qualifications = [];
  educations.forEach((item) => {
    const { name, date } = item.educationDegrees?.[0] || {};
    const rawDate = (date || '').trim();

    let validDate;
    if (/^\d{4}$/.test(rawDate)) {
      validDate = `${rawDate}-01`; // or `${date}-01-01` if you prefer full date
    } else if (!isNaN(Date.parse(rawDate))) {
      validDate = new Date(rawDate).toISOString().split('T')[0];
    } else {
      validDate = null;
    }

    const edu = {
      name: name,
      date: validDate || null,
      description: item.institution?.name
    }

    if (Array.isArray(item.descriptions) && item.descriptions.length > 0) {
      edu.description = [...item.descriptions];
    }

    if (!Array.isArray(formData.qualification)) {
        formData.qualification = [];
    }

    qualifications.push(edu);
  });

  formData.qualification = qualifications;
};

const populateAddress = (person, formData) => {
  const address = person?.communication?.address;
console.log("address", address);
  if (!Array.isArray(address) || address.length === 0) {
    return;
  }
  const addr = address[0];

  formData.address.streetAddress = addr.formattedAddress || formData.streetAddress;
  formData.address.placeName = addr.city || formData.placeName;
  formData.address.postalCode = addr.postalCode || formData.postalCode;
  formData.address.locationCode = addr.postalCode || formData.locationCode;
  formData.address.countryCode = addr.countryCode || formData.countryCode;
  //formData.address.admin1Name = addr.countrySubDivisions.length > 0 ? addr.countrySubDivisions[0].value : formData.admin1Name;
};

const convertToSkillObject = (skills) => {
    return skills.map((s) => s);
};

const convertQualificationToSkills = (skills) => {
  return skills.map((s) => s.competencyName);
};

export const overridePopulateDataFromProfile = (formData, profile) => {
  const candidateProfile = profile?.candidateProfile;
  if (!candidateProfile) return formData;

  var person = candidateProfile.candidate?.person;
  if (person) {
    formData.firstName = person.name.given;
    formData.lastName = person.name?.family;
    formData.email = person?.communication?.email[0]?.address;
    formData.confirmEmail = person?.communication?.email[0]?.address;
    formData.profileId = profile.candidateProfile.profileId?.value;

    const phone = person?.communication?.phone?.[0]?.formattedNumber;

      if (phone) {
        if (!formData.primaryContactNumber) {
          formData.primaryContactNumber = phone;
        } else if (!formData.secondaryContactNumber) {
          formData.secondaryContactNumber = phone;
        }
      }

      populateAddress(person, formData);
    }

    formData.executiveSummary = candidateProfile.executiveSummary;

    const noticePeriod = candidateProfile.personAvailability?.noticePeriodMeasure;
    if (noticePeriod) {
      formData.noticePeriod = `${noticePeriod?.value} ${noticePeriod.unitCode === "WEE" ? "Weeks" : ""} `;
    }

    if (candidateProfile.qualifications && candidateProfile.qualifications.length > 0) {
      formData.skills = JSON.stringify(convertQualificationToSkills(profile.candidateProfile.qualifications));
    }
    console.log("profile", profile);
console.log("candidateprofile", candidateProfile);
    populateEmployments(candidateProfile, formData);
    populateEducations(candidateProfile, formData);

    if (profile.cv?.upload) {
      formData.cv = profile.cv;
    }

    return formData;
  };

export const setCountryValidation = (schema, formData) => {
  let makeRequired = "region";
  let makeRequiredUA = ["admin1Name", "admin1Code", "placeName", "postalCode"];

  // other countries
  if (formData.address && formData.address.countryCode !== "US" && formData.address.countryCode !== "AU") {
    // reset required
    makeRequiredUA.map((requiredProp) => {
      delete schema.properties.address.required[schema.properties.address.required.indexOf(requiredProp)];
    });

    // Set the region field to required
    if (schema.properties.address.required.indexOf(makeRequired) === -1) {
      schema.properties.address.required.push(makeRequired);
    }
    schema.properties.address.properties.region.minLength = 1;
    delete schema.properties.address.properties.admin1Name.not;
  } else {
    // US and AU
    makeRequiredUA.map((requiredProp, counter) => {
      if (schema.properties.address.required.indexOf(makeRequiredUA[counter]) === -1) {
        schema.properties.address.required.push(makeRequiredUA[counter]);
      }
    });
    let notDefault = {
      not: {
        pattern: ["Default"],
      },
    };
    schema.properties.address.properties.region.minLength = 0;
    schema.properties.address.properties.admin1Name = notDefault;

    // Copy address fields
    formData.address.locationCode =
      formData.address && formData.address.postalCode ? formData.address.postalCode : formData.address.locationCode;
    formData.address.region =
      formData.address && formData.address.placeName ? formData.address.placeName : formData.address.region;
  }

  //As we mark postalCode as required but we are not taking it value and we simplying mapping user locationcode user inputs to postalCode.
  if (formData.address.locationCode && formData.address.postalCode !== formData.address.locationCode) {
    formData.address.postalCode = formData.address.locationCode;
  }

  if (formData.address && formData.address.countryCode !== formData.address.countryCode) {
    if (typeof formData.address.region == "undefined") {
      formData.address.region = "";
    }
  }

  return {
    schema: schema,
    formData: formData,
  };
};

const deduplicateArray = (arr) => {
  if (!Array.isArray(arr)) return arr;
  try {
    return Array.from(new Set(arr.map((item) => (typeof item === 'object' ? JSON.stringify(item) : item))))
      .map((item) => (typeof item === 'string' && item.startsWith('{') ? JSON.parse(item) : item));
  } catch(e) {
    return [...new Set(arr)];
  }
};

const setJobPreferences = (newFormData, candidate) => {
  if (candidate.jobStatusPreferences) {
    newFormData.candidate.jobStatusPreferences = deduplicateArray(candidate.jobStatusPreferences);
  }
  if (candidate.jobTypePreferences) {
    newFormData.candidate.jobTypePreferences = deduplicateArray(candidate.jobTypePreferences);
  }
  if (candidate.occupationPreferences) {
    newFormData.candidate.occupationPreferences = deduplicateArray(candidate.occupationPreferences);
  }
  if (candidate.locationPreferences && candidate.locationPreferences.length > 0) {
    newFormData.candidate.locationPreferences = deduplicateArray(candidate.locationPreferences);
  }
};

const setAddressFromJob = (address, job, isBasicApplication = false) => {
  address.countryCode = job && job.address ? job.address.countryCode : "US";
  address.region = job && job.address && job.address.admin1Name !== null ? job.address.admin1Name : "";
  address.placeName = job && job.address ? job.address.placeName : "Default";
  address.postalCode = job && job.address ? job.address.postalCode : "Default";
  address.admin1Code = job && job.address && job.address.admin1Code !== null ? job.address.admin1Code : "";
  address.admin1Name =
    job && job.address && job.address.admin1Name !== null
      ? job.address.admin1Name
      : isBasicApplication
      ? ""
      : "Default"; //Fixed 8230
  return address;
};

const initializeAddress = (address, job, isBasicApplication = false) => {
  if (address) {
    if (!address.countryCode) {
      address = setAddressFromJob(address, job, isBasicApplication);
    }
  } else {
    address = {};
    address = setAddressFromJob(address, job, isBasicApplication);
  }
  return address;
};

const getSkills = (newFormData, candidate) => {
  if (newFormData.skills && newFormData.skills !== "") {
    return newFormData.skills;
  } else {
    return candidate.skills && candidate.skills !== "undefined" ? candidate.skills : "";
  }
};

export const prePopulateDataFromCandidate = (formData, job, candidate, isBasicApplication = false) => {
  let newFormData = cloneDeep(formData);
  if (candidate && typeof candidate !== "undefined" && candidate !== null) {
    newFormData.firstName = candidate.firstName;
    newFormData.lastName = candidate.lastName;
    newFormData.email = candidate.email;
    newFormData.confirmEmail = candidate.email;
    if (!isBasicApplication) {
      newFormData.skills = getSkills(newFormData, candidate);
    }
    newFormData.executiveSummary =
      newFormData.executiveSummary !== ""
        ? newFormData.executiveSummary
        : candidate.executiveSummary && candidate.executiveSummary !== "undefined"
        ? candidate.executiveSummary
        : "";
    newFormData.noticePeriod =
      newFormData.noticePeriod !== ""
        ? newFormData.noticePeriod
        : candidate.noticePeriod && candidate.noticePeriod !== "undefined"
        ? candidate.noticePeriod
        : "";
    newFormData.candidateId = candidate.id;

    if (!newFormData.candidate) {
      newFormData.candidate = {};
    }

    if (!isBasicApplication) {
      setJobPreferences(newFormData, candidate);
    }

    if (!newFormData.id) {
      // if add pre-fill by profile
      newFormData = Object.assign(newFormData, candidate);
      //remove ids
      delete newFormData.id;
      if (newFormData.address) {
        let cloneAddress = Object.assign({}, newFormData.address);
        delete cloneAddress.id;
        newFormData.address = cloneAddress;
        // delete newFormData.address.id;
      }
      if (Array.isArray(newFormData.employment)) {
        let newEmploymet = [];
        newFormData.employment.forEach(function (employment) {
          let employmentWithOutId = cloneDeep(employment);
          delete employmentWithOutId.id;
          newEmploymet.push(employmentWithOutId);
        });
        newFormData.employment = newEmploymet;
      }
      if (Array.isArray(newFormData.qualification)) {
        let newQualification = [];
        newFormData.qualification.forEach(function (qualification) {
          let qualificationWithOutId = cloneDeep(qualification);
          delete qualificationWithOutId.id;
          newQualification.push(qualificationWithOutId);
        });
        newFormData.qualification = newQualification;
      }
      //override property diff
      //newFormData.applicationMessage = newFormData.applicationMessage;
    }

    if (candidate.cv && !candidate.cv.upload) {
      let cv = Object.assign({}, candidate.cv);
      cv.upload = candidate.cv.id;
      newFormData.candidate.cv = cv;
      newFormData.cv = cv;
      // newFormData.candidate.cv.upload = candidate.cv.id;
    }
  }
  newFormData.address = initializeAddress(newFormData.address, job, isBasicApplication);

  return newFormData;
};

export const setCvAndCoverletterRequiredOrOptional = (job, schema) => {
  const resumeRequired = !!job?.isResumeCompulsory;
  const coverletterRequired = !!job?.coverletterCompulsory;

  const newSchema = Immutable.fromJS(schema)
    .set("definitions", {
      ...schema.definitions,
      requiredDocument: {
        ...schema.definitions.requiredDocument,
        required: resumeRequired ? ["upload"] : [],
      },
      requiredCoverletter: {
        ...schema.definitions.requiredCoverletter,
        required: coverletterRequired ? ["upload"] : [],
      },
    })
    .updateIn(["required"], (arr) => {
      const required = [...arr];

      const cvIndex = required.indexOf("cv");
      if (resumeRequired && cvIndex < 0) {
        required.push("cv");
      } else if (!resumeRequired && cvIndex > -1) {
        required.splice(cvIndex, 1);
      }

      const coverLetterIndex = required.indexOf("coverLetter");
      if (coverletterRequired && coverLetterIndex < 0) {
        required.push("coverLetter");
      } else if (!coverletterRequired && coverLetterIndex > -1) {
        required.splice(coverLetterIndex, 1);
      }

      return required;
    })
    .setIn(["properties", "cv", "$ref"], resumeRequired ? "#/definitions/requiredDocument" : "#/definitions/document")
    .setIn(
      ["properties", "coverLetter", "$ref"],
      coverletterRequired ? "#/definitions/requiredCoverletter" : "#/definitions/document"
    )
    .toJS();
  if (newSchema.properties.firstName.minLength.length > 1) {
    newSchema.properties.firstName.minLength = schema.properties.firstName.minLength;
    newSchema.properties.lastName.minLength = schema.properties.lastName.minLength;
  }
  return newSchema;
};

export const getLastMandatoryStep = (steps) => {
  let lastStep = 0;
  let counter = 0;
  if (steps && steps.length > 0) {
    steps.map((step) => {
      if (step.required === true) {
        lastStep++;
      }
      counter++;
    });
    return lastStep;
  }

  return -1;
};

export const setParsedAddress = (parsedAddress, address) => {
  if (parsedAddress !== null && parsedAddress.admin1Code !== "Default" && address.admin1Name === "Default") {
    return parsedAddress;
  } else {
    return address;
  }
};

export const checkJobExpiredAndApplicationAllowed = (job, newFormData, history) => {
  const currentDate = new Date();
  let expiryDate = new Date(job?.jobAdvertExpiryDate);
  expiryDate.setDate(expiryDate.getDate() + 30);

  if (
    (job?.expired && !job?.allowApplicationsAfterExpiry) ||
    (job?.expired && job?.allowApplicationsAfterExpiry && expiryDate < currentDate) ||
    (job?.expired &&
      job?.allowApplicationsAfterExpiry &&
      expiryDate > currentDate &&
      !Object.prototype.hasOwnProperty.call(newFormData, "imported")) ||
    (job?.expired &&
      job?.allowApplicationsAfterExpiry &&
      Object.prototype.hasOwnProperty.call(newFormData, "imported") &&
      !newFormData.imported)
  ) {
    history.push("/404.html");
  }
};

export const highlightRequiredQuestions = () => {
  const formSubmitButton = document.getElementsByClassName("sv_complete_btn");

  if (formSubmitButton && formSubmitButton.length > 0) {
    formSubmitButton[0].click();
  }
};
